export var FreewheelParameterType;
(function (FreewheelParameterType) {
    FreewheelParameterType["GLOBAL"] = "Global";
    FreewheelParameterType["SITE"] = "Site";
    FreewheelParameterType["CUSTOM"] = "Custom";
})(FreewheelParameterType || (FreewheelParameterType = {}));
